import "froala-editor/js/froala_editor.pkgd.min.js";
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { RebusAdminApp } from './app.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { ENV } from '@app/env';
import { PROVIDERS } from '../providers/index';
import { SharedComponentsModule } from '../components/shared-components.module';
import { SharedModule } from '../shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PollFormQuestionAnswerComponent } from "../pages/poll/components/question-answer-form/question-answer-form.component";
import { CategoriesFormComponent } from "../pages/categories/components/categories-form/categories-form.component";
import { PipesModule } from "../pipes/pipes.module";
import { VotingFormQuestionAnswerComponent } from "../pages/voting/components/questions-answers-form/questions-answers-form.component";
import { ShopsFormComponent } from "../pages/shops/components/shops-form/shops-form.component";
import { CouponsFormComponent } from "../pages/coupons/components/coupons-form/coupons-form";
import { ProfileUsersFormComponent } from "../pages/interactivity/pages/profiles-users/components/profile-users-form/profile-users-form.component";
import { FormUsersFormComponent } from "../pages/form-users/components/form-users-form/form-users-form.component";
import { FormQuestionComponent } from "../pages/form-users/components/form-question/form-question.component";
import { BusinessViewFormComponent } from "../pages/interactivity/pages/business-view/components/business-view-form/business-view-form";
import { BusinessAgendaFormComponent } from "../pages/interactivity/pages/business-view/components/business-agenda-form/business-agenda-form";
import { DirectivesModule } from "../directives/directives.module";

export const FIREBASE_CONFIG = {
  apiKey: ENV.firebase.apiKey,
  authDomain: ENV.firebase.authDomain,
  databaseURL: ENV.firebase.databaseURL,
  projectId: ENV.firebase.projectId,
  storageBucket: ENV.firebase.storageBucket,
  messagingSenderId: ENV.firebase.messagingSenderId
};

@NgModule({
  declarations: [
    RebusAdminApp,
    PollFormQuestionAnswerComponent,
    VotingFormQuestionAnswerComponent,
    CategoriesFormComponent,
    CouponsFormComponent,
    ProfileUsersFormComponent,
    ShopsFormComponent,
    FormUsersFormComponent,
    FormQuestionComponent,
    BusinessViewFormComponent,
    BusinessAgendaFormComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(RebusAdminApp, {
      mode: 'md'
    }),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    !(ENV.mode === 'Production') ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
    SharedComponentsModule,
    SharedModule,
    HttpClientModule,
    PipesModule,
    DirectivesModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    RebusAdminApp,
    PollFormQuestionAnswerComponent,
    VotingFormQuestionAnswerComponent,
    CategoriesFormComponent,
    CouponsFormComponent,
    ProfileUsersFormComponent,
    ShopsFormComponent,
    FormUsersFormComponent,
    FormQuestionComponent,
    BusinessViewFormComponent,
    BusinessAgendaFormComponent
  ],
  providers: [
    ...PROVIDERS,
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts